  <!-- 新建客户档案 -->
  <template>
  <div id="Custom_create">
    <div class="Custom_title">
      <div
        class="content"
        v-for="(item, index) in options"
        :key="index"
        :class="{ activeItem: currentTab === item.tabModName }"
        @click="itemClick(item.tabModName)"
      >
        <span>{{ item.tabName }}</span>
      </div>
      <div class="border"></div>
    </div>
    <!-- <keep-alive v-if="isRouterAlive">
      <component :is="currentTab" :common="commonData" @RELOADPAGE="reloadpage" />
    </keep-alive> -->
    <baseinfo
      v-show="currentTab=='baseinfo'"
      :common="commonData"
      @RELOADPAGE="reloadpage"
    />
    <persons
      v-show="currentTab=='persons'"
      :common="commonData"
      @RELOADPAGE="reloadpage"
    />
    <shippingaddr
      v-show="currentTab=='shippingaddr'"
      :common="commonData"
      @RELOADPAGE="reloadpage"
    />
    <shouhuoaddr
      v-show="currentTab=='shouhuoaddr'"
      :common="commonData"
      @RELOADPAGE="reloadpage"
    />
    <refund
      v-show="currentTab=='refund'"
      :common="commonData"
      @RELOADPAGE="reloadpage"
    />
    <contractManagement
      v-show="currentTab=='contractManagement'"
      :common="commonData"
      @RELOADPAGE="reloadpage"
    />
  </div>
</template>
  <script >
import baseinfo from '@/pages/Customers/CustomMOD/BaseInfo.vue'
import persons from '@/pages/Customers/CustomMOD/Persons.vue'
import shippingaddr from '@/pages/Customers/CustomMOD/ShippingAddr.vue'
import shouhuoaddr from '@/pages/Customers/CustomMOD/ShouhuoAddr.vue'
import refund from '@/pages/Customers/CustomMOD/Refund.vue'
import contractManagement from '@/pages/Customers/CustomMOD/contractManagement.vue'
// import invocing from "@/pages/Customers/CustomMOD/Invoicing.vue";
export default {
  inject: ['reload'],

  components: {
    baseinfo,
    persons,
    shippingaddr,
    shouhuoaddr,
    refund,
    contractManagement,
    // invocing,
  },
  data() {
    return {
      isRouterAlive: true,
      options: [
        {
          tabName: '基础信息',
          tabModName: 'baseinfo',
        },
        {
          tabName: '人员管理',
          tabModName: 'persons',
        },
        {
          tabName: '发货地址',
          tabModName: 'shippingaddr',
        },
        {
          tabName: '收货地址',
          tabModName: 'shouhuoaddr',
        },
        {
          tabName: '收款账户',
          tabModName: 'refund',
        },
        {
          tabName: '合同管理',
          tabModName: 'contractManagement',
        },
        // {
        //   tabName: "代收货款资料",
        //   tabModName: "invocing",
        // },
      ],
      commonData: {
        customerId: null,
        customerNumber: null,
      },
      currentTab: 'baseinfo',
    }
  },
  created() {
    if (this.$route.query.customerId) {
      this.commonData.customerId = this.$route.query.customerId
      this.commonData.customerNumber = this.$route.query.number
    }
  },
  watch: {
    $route(to, from) {
      let id = this.$route.query.customerId || ''
      if (to.path == '/Customers/CustomMOD/Edit' && id) {
        this.reload()
      }
    },
  },
  methods: {
    itemClick(tab) {
      this.currentTab = tab
    },

    reloadpage() {
      this.$TOOLS.closePage()
      this.$router.push({
        path: '/Customers/Custom',
        query: {
          isreload: 'isreload',
        },
      })
    },
  },
}
</script>
  <style scoped lang="less">
.Custom_title {
  background: #fff;
  // border-bottom: 1px solid #eee;
  color: rgba(0, 0, 0, 0.802);
  display: flex;
  .content {
    padding: 10px 26px;
    border: 1px solid #cccccc;
    cursor: pointer;
    border-right: none;
  }
  .content:first-child {
    border-top-left-radius: 6px;
  }
  .content:nth-of-type(6) {
    border-right: 10px solid #cccccc;
    border-top-right-radius: 6px;
  }
  .border {
    flex: 1;
    border-bottom: 1px solid #cccccc;
  }
  .activeItem {
    background: #fff;
    color: #ef7c0a;
    border-bottom: #fff;
    // border-bottom: rgb(229, 49, 49) 2px solid;
  }
}
</style>
  